// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import api from "./assets/js/request/api/index";
import fnc from "./assets/js/fnc.js";
Vue.prototype.$api = api;
Vue.prototype.$fnc = fnc
Vue.config.productionTip = false


import { RadioGroup, Radio, Uploader, Popup, Icon, Button, Field, Form, Picker, DatetimePicker, Overlay, NavBar, Checkbox, CheckboxGroup, Cell, CellGroup, NoticeBar } from 'vant';
Vue.use(Icon)
  .use(Field)
  .use(NavBar)
  .use(Form)
  .use(Button)
  .use(Picker)
  .use(Popup)
  .use(DatetimePicker)
  .use(Uploader)
  .use(Overlay)
  .use(Checkbox)
  .use(CellGroup)
  .use(Cell)
  .use(CheckboxGroup)
  .use(NoticeBar)
  .use(RadioGroup)
  .use(Radio)
/* eslint-disable no-new */

let isFirstRoute = true;

router.beforeEach((to, from, next) => {
  // if (!isFirstRoute) {
  if (!store.state.isLogin && to.meta.auth) {
    next({
      path: '/'
    })
    return
  }
  // } else {
  //   isFirstRoute = false;
  // }
  next();
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")